<template>
  <div>
    <button
      class="navbar__bottom-item"
      @click="isOpen = !isOpen"
      :title="isOpen ? $t('close') : $t('open')"
    >
      <span class="navbar__bottom-item-label">{{ category.title }}</span>
      <span :class="['navbar__bottom-item-toggle', { '--open': isOpen }]"
        ><span v-for="item in 2" :key="item"></span
      ></span>
    </button>
    <div :class="['category__menu-container', { '--closed': !isOpen }]">
      <CategoryMenu :category="category" />
    </div>
  </div>
</template>

<script>
import CategoryMenu from '@/components/navigation/CategoryMenu.vue'
import { HasCategory } from '@/mixins'

export default {
  name: 'MobileCategoryMenu',
  mixins: [HasCategory],
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  components: { CategoryMenu },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    category() {
      return this.getCategory(this.content.category)
    },
  },
  watch: {
    $route() {
      if (this.isOpen) this.isOpen = false
    },
  },
}
</script>
